import { ModuleConfig, config } from "/@/cool";
import { useStore } from "./store";
import { App } from "vue";
import Admin from "@cool-vue/admin";
import "@cool-vue/admin/dist/index.css";
import "./static/css/index.scss";

export default (): ModuleConfig => {
	return {
		order: 99,
		views: [
			{
				path: "/my/info",
				meta: {
					label: "个人中心"
				},
				component: () => import("./views/info.vue")
			}
		],
		pages: [
			{
				path: "/login",
				component: () => import("./pages/login/index.vue")
			},
			{
				path: "/401",
				meta: {
					process: false
				},
				component: () => import("./pages/error-page/401.vue")
			},
			{
				path: "/403",
				meta: {
					process: false
				},
				component: () => import("./pages/error-page/403.vue")
			},
			{
				path: "/404",
				meta: {
					process: false
				},
				component: () => import("./pages/error-page/404.vue")
			},
			{
				path: "/500",
				meta: {
					process: false
				},
				component: () => import("./pages/error-page/500.vue")
			},
			{
				path: "/502",
				meta: {
					process: false
				},
				component: () => import("./pages/error-page/502.vue")
			}
		],
		install(app: App) {
			// 基础库
			app.use(Admin);

			// 设置标题
			document.title = config.app.title_name;
		},
		async onLoad() {
			const { user, menu, app } = useStore();

			// token 事件
			async function hasToken(cb: () => Promise<any> | void) {
				if (cb) {
					app.addEvent("hasToken", cb);

					if (user.token) {
						await cb();
					}
				}
			}

			await hasToken(async () => {
				// 获取用户信息
				user.get().catch((err) => {
					console.warn("[base] 获取用户信息失败，不阻断页面启动:", err?.message || err);
				});

				// 获取菜单权限
				try {
					await menu.get();
				} catch (err: any) {
					console.warn(
						"[base] 获取菜单权限失败，继续使用本地缓存启动:",
						err?.message || err
					);
				}
			});

			return {
				hasToken
			};
		}
	};
};
